import {LeagueRoundResultContext} from "./league-round-result-context";
import {LeagueStandingsViewMode} from "./league-standings-view-mode";
import {TeamComposition} from "./league-competitor";

export class LeagueRoundResultsFilter {
    constructor(
        public raceId: LeagueStandingsViewMode = LeagueStandingsViewMode.PUBLIC,
        public gender?: number,
        public categoryItemId?: number,
        public searchTerm?: number,
        public teamComposition?: TeamComposition,
        public context: LeagueRoundResultContext = LeagueRoundResultContext.ROUND
    ) {
    }
}
